import { render } from "./UspReportStatusBadge.vue?vue&type=template&id=9550a1f4&scoped=true"
import script from "./UspReportStatusBadge.vue?vue&type=script&lang=js"
export * from "./UspReportStatusBadge.vue?vue&type=script&lang=js"

import "./UspReportStatusBadge.vue?vue&type=style&index=0&id=9550a1f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9550a1f4"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon});
